export default __webpack_public_path__ + "img/shape-heart-small.b3b806ff.svg";